export const colors = {
  lightBlue: '#C1D9FB',
  blue: '#3242AA',
  grey: '#E8E8ED',
  red: '#E8210F',
  lightYellow: '#FFFEE3',
  transparent: 'transparent',
  black: 'black',
};
